
// src/connects/diary-comment.js

import PropTypes from 'prop-types'
import ui from '../helpers/ui-state'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import { pushRoute } from '../actions/route'
import combineHOC from '../helpers/combine-hoc'
import context from '../helpers/context'
import find from 'lodash/find'

export const mapStateToProps = (state)=> {
  return {
    isShowTimeStamp: state.showTimeStamp.isEnable,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    deleteComment: ()=> dispatch(actions.deleteComment(ownProps.comment.comment_id)),
    likeComment:   ()=> dispatch(actions.likeComment(ownProps.comment.comment_id)),
    unlikeComment: ()=> {
      var like = find(ownProps.comment.likes, (_like)=> _like.user.user_id == ownProps.user.user_id)
      like && dispatch(actions.deleteLike(like.like_id))
    },
    reactionComment: (like_type)=> dispatch(actions.likeComment(ownProps.comment.comment_id, like_type)),

    submitStamp: (code, props) => {
      if (!code)
        return
      dispatch(actions.postComment(
        'comment_id', props.comment.comment_id,
        `<div><span class="stamp ${code}"></span></div>`
      ))
    },

    showUser:  ()=> dispatch(actions.openRightSidePage('user_timeline', { group_id: !ownProps.diary.group && ownProps.group && ownProps.group.group_id || undefined, user_id: ownProps.comment.user.user_id })),
    showAttachments: ()=> dispatch(actions.openRightSidePage('attachments', { diary_id: ownProps.diary.diary_id, comment_id: ownProps.comment.comment_id }, true)),
    showReaders:     (props)=> dispatch(actions.openRightSidePage('likes_readers', { diary_id: ownProps.diary.diary_id, comment_id: props.comment_id ? props.comment_id : ownProps.comment.comment_id, tab: props.types }, true)),
    showMentions:    (props)=> dispatch(actions.openRightSidePage('likes_readers', { diary_id: ownProps.diary.diary_id, comment_id: props.comment_id ? props.comment_id : ownProps.comment.comment_id, tab: props.types }, true)),
    showComments:    ()=> dispatch(actions.openRightSidePage('likes_readers', { diary_id: ownProps.diary.diary_id, comment_id: ownProps.comment.comment_id, tab: 'comments' }, true)),
    postContentReport: () => {
      dispatch(actions.postContentReport(ownProps.user.user_id, ownProps.diary.diary_id, ownProps.comment.comment_id))
    }
  }
}

export default combineHOC(
  ui({ 
    state: { 
      openCommentReaction: false,
      openReplyReaction: false,
    }
  }),
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  context({ showImagesView: PropTypes.func, showStampPalette: PropTypes.func }),
)



// WEBPACK FOOTER //
// ./src/connects/diary-comment.js